import React from 'react';
import { useLang } from '../LangContext';

const SECTION_MAP = [null, '#about', '#stack', '#exp', '#projects', null, '#services', '#contact'];

export default function Nav({ onTweaks, panelOpen, active, soundOn, toggleSound }) {
  const { lang, toggleLang, t } = useLang();
  const activeHref = SECTION_MAP[active] ?? null;

  return (
    <nav className="nav">
      <div className="nav__brand">
        <span className="nav__brand-dot" />
        <span>TRAORE LAMINE — v2.0</span>
      </div>
      <div className="nav__links">
        {t.nav.links.map(({ href, label }) => (
          <a
            key={href}
            href={href}
            className={activeHref === href ? 'nav__link--active' : ''}
          >
            {label}
          </a>
        ))}
      </div>
      <div className="nav__right">
        <button className="nav__lang" onClick={toggleLang} title={lang === 'fr' ? 'Switch to English' : 'Passer en français'}>
          <span className={lang === 'fr' ? 'nav__lang-active' : ''}>FR</span>
          <span className="nav__lang-sep">/</span>
          <span className={lang === 'en' ? 'nav__lang-active' : ''}>EN</span>
        </button>
        <button
          className={`nav__sound${soundOn ? ' nav__sound--on' : ''}`}
          onClick={toggleSound}
          title={soundOn
            ? (lang === 'fr' ? 'Couper la pluie' : 'Mute rain')
            : (lang === 'fr' ? 'Pluie ambiante' : 'Ambient rain')}
          aria-label={soundOn ? 'Mute ambient sound' : 'Play ambient sound'}
        >
          ∿
        </button>
        <button
          className={`nav__tweak-btn${panelOpen ? ' nav__tweak-btn--active' : ''}`}
          onClick={onTweaks}
          aria-label={t.nav.ariaCustomize}
        >
          ⊙
        </button>
        <div className="nav__status">
          <span className="nav__status-dot" />
          <span>{t.nav.status}</span>
        </div>
      </div>
    </nav>
  );
}
